import React from "react";

export default function Footer() {
  return (
    <footer className="footer">
      <p className="footer-text">
        Made by{" "}
        <a
          href="https://ozthorn.co.uk"
          target="_blank"
          rel="noopener noreferrer"
        >
          Oz Thorn
        </a>{" "}
        <br />
        for{" "}
        <a
          href="https://clwbnawa.co.uk"
          target="_blank"
          rel="noopener noreferrer"
        >
          Clwb Nawa
        </a>
      </p>
    </footer>
  );
}
